// @flow
import React, { type Node } from 'react';
import { MdCloudUpload } from 'react-icons/md';
import './EstimateTemplate.scss';
import EstimateGuide from '../EstimateGuide';

type Props = {
  children: Node,
};

const guideDescriptions = [
  '요청 양식을 다운로드합니다',
  '양식에 맞춰 내용을 작성합니다',
  '작성한 파일을 업로드합니다',
  '"보기" 버튼을 클릭한 후 견적서를 확인합니다.',
];

const EstimateTemplate = ({ children }: Props) => (
  <div className="EstimateTemplate">
    <div className="main">
      <h2>
        <MdCloudUpload />
        견적 요청
      </h2>
      <h4>
        더 이상 여러 업체에 견적 요청하실 필요가 없습니다. <br />
        원하는 제품 리스트를 엑셀로 등록하면 캐시바이가 견적서를 전달 드립니다.
      </h4>
      <EstimateGuide descriptions={guideDescriptions} />
      {children}
    </div>
  </div>
);

export default EstimateTemplate;



// WEBPACK FOOTER //
// ./src/components/estimate/EstimateTemplate/EstimateTemplate.js